import { Check } from "lucide-react";
import { DROP_STATUSES } from "@/lib/api";

const STEPS = ["ordered", "arrived_pastelfix", "sorting", "shipped_areku", "arrived_areku", "packing"];
const LABEL = Object.fromEntries(DROP_STATUSES);

export const StatusTimeline = ({ status }) => {
  const at = STEPS.indexOf(status);
  if (at < 0) return null;
  return (
    <div data-testid="status-timeline" className="mt-5 max-w-2xl rounded-2xl border border-sky-500/20 bg-sky-500/[0.04] p-4">
      <div className="text-[11px] uppercase tracking-widest text-sky-300 font-semibold">Order progress</div>
      <ol className="mt-3 grid grid-cols-6 gap-1">
        {STEPS.map((s, i) => {
          const done = i < at;
          const now = i === at;
          return (
            <li key={s} data-testid={`timeline-step-${s}`} data-state={done ? "done" : now ? "current" : "upcoming"} className="flex flex-col items-center text-center">
              <div className="relative flex w-full items-center justify-center">
                {i > 0 && <span className={`absolute right-1/2 h-0.5 w-full ${i <= at ? "bg-sky-400" : "bg-zinc-700"}`} />}
                <span className={`relative z-10 flex h-6 w-6 items-center justify-center rounded-full border text-[10px] font-bold transition-colors
                  ${done ? "bg-sky-400 border-sky-400 text-zinc-950" : now ? "bg-zinc-950 border-sky-300 text-sky-200 ring-4 ring-sky-400/20" : "bg-zinc-900 border-zinc-700 text-zinc-500"}`}>
                  {done ? <Check className="h-3.5 w-3.5" /> : i + 1}
                </span>
              </div>
              <span className={`mt-1.5 text-[10px] sm:text-[11px] leading-tight ${now ? "font-semibold text-sky-100" : done ? "text-zinc-300" : "text-zinc-500"}`}>{LABEL[s]}</span>
            </li>
          );
        })}
      </ol>
    </div>
  );
};
